<div class="contact-form-container">
  <h1>{{ 'contacto.titulo' | translate }}</h1>
  <p class="subtitle">{{ 'contacto.subtitulo' | translate }}</p>

  <form [formGroup]="contactForm" class="contact-form" autocomplete="on">
    <!-- Contact Details -->
    <div class="form-section">
      <h2 class="section-title">{{ 'contacto.datosMensaje' | translate }}</h2>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Razón de contacto</mat-label>
        <mat-select formControlName="reason" required>
          <mat-option value="general">Consulta General</mat-option>
          <mat-option value="purchase-problem">Problemas con mi compra</mat-option>
          <mat-option value="publicadx">Quisiera ser publicadx</mat-option>
          <mat-option value="feedback">Feedback</mat-option>
          <mat-option value="other">Otra</mat-option>
        </mat-select>
        <mat-icon matPrefix>help</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width" *ngIf="showOrderNumber">
        <mat-label>Número de orden</mat-label>
        <input matInput formControlName="orderNumber" type="number">
        <!-- <mat-icon matPrefix></mat-icon> -->
        <mat-error *ngIf="contactForm.get('orderNumber')?.errors">
          Por favor escriba un número de orden válido.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Mensaje</mat-label>
        <textarea matInput formControlName="message" rows="5" required></textarea>
        <mat-error *ngIf="contactForm.get('message')?.hasError('required')">
          Mensaje requerido
        </mat-error>
        <mat-error *ngIf="contactForm.get('message')?.hasError('minlength')">
          El mensaje tiene un mínimo de 10 caracteres.
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Personal Information -->
    <div class="form-section">
      <h2 class="section-title">{{ 'contacto.informacion' | translate }}</h2>

      <div class="row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'contacto.nombre' | translate }}</mat-label>
          <input matInput formControlName="name" required autocomplete="on">
          <mat-icon matPrefix>person</mat-icon>
          <mat-error *ngIf="contactForm.get('name')?.hasError('required')">
            {{ 'contacto.nombreMsjErrorRequerido' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'contacto.email' | translate }}</mat-label>
        <input matInput formControlName="email" type="email" required autocomplete="on">
        <mat-icon matPrefix>email</mat-icon>
        <mat-error *ngIf="contactForm.get('email')?.hasError('required')">
          {{ 'contacto.emailMsjErrorRequerido' | translate }}
        </mat-error>
        <mat-error *ngIf="contactForm.get('email')?.hasError('pattern')">
          {{ 'contacto.emailMsjErrorValido' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Teléfono</mat-label>
        <input matInput formControlName="phone" type="tel" autocomplete="on">
        <mat-icon matPrefix>phone</mat-icon>
        <mat-error *ngIf="contactForm.get('phone')?.hasError('pattern')">
          {{ 'contacto.phoneMsjErrorValido' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Preferences -->
    <div class="form-section">
      <h2 class="section-title">Preferencias</h2>

      <mat-checkbox formControlName="newsletter">
        Suscribirse al newsletter
      </mat-checkbox>

      <mat-checkbox formControlName="allowContact" required *ngIf="showOrderNumber">
        Estoy de acuerdo que me contacten.
        <mat-error *ngIf="contactForm.get('allowContact')?.hasError('required')">
          Debe aceptar para continuar.
        </mat-error>
      </mat-checkbox>
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
      <button mat-raised-button type="submit" [class.disabled]="!contactForm.valid" (click)="onSubmit()">
        Enviar
      </button>
      <!--
      <button mat-button type="button" (click)="resetForm()">
        Clear Form
      </button> -->
    </div>
  </form>
</div>